import { Checkbox } from 'antd';

export const ACCESS_LEVEL_KEY_MAPPING = {
    hide: 'HIDE',
    view: 'VIEW',
    add: 'ADD',
    p_update: 'P_UPDATE',
    f_update: 'F_UPDATE',
    delete: 'DELETE',
};

export const ACCESS_LEVEL_VALUE_MAPPING = {
    HIDE: 'hide',
    VIEW: 'view',
    ADD: 'add',
    P_UPDATE: 'p_update',
    F_UPDATE: 'f_update',
    DELETE: 'delete',
};

const renderPermissionCheckbox = (record, permissionKey, handlePermissionChange, disabled = false) => (
    <Checkbox
        checked={record?.[permissionKey]}
        disabled={disabled}
        onChange={(event) => handlePermissionChange(record?.key, permissionKey, event?.target?.checked)}
    />
);

export const ACCESS_COLUMNS = (handlePermissionChange) => [
    {
        title: 'Menu Name',
        dataIndex: 'menuName',
        key: 'menuName',
        width: '20%',
    },
    {
        title: 'Hide',
        dataIndex: 'hide',
        key: 'hide',
        align: 'center',
        render: (text, record) => renderPermissionCheckbox(record, 'hide', handlePermissionChange),
    },
    {
        title: 'View',
        dataIndex: 'view',
        key: 'view',
        align: 'center',
        render: (text, record) => renderPermissionCheckbox(record, 'view', handlePermissionChange, record?.hide),
    },
    {
        title: 'Add',
        dataIndex: 'add',
        key: 'add',
        align: 'center',
        render: (text, record) => renderPermissionCheckbox(record, 'add', handlePermissionChange, record?.hide),
    },
    {
        title: 'F_Update',
        dataIndex: 'f_update',
        key: 'f_update',
        align: 'center',
        render: (text, record) => renderPermissionCheckbox(record, 'f_update', handlePermissionChange, record?.hide),
    },
    {
        title: 'P_Update',
        dataIndex: 'p_update',
        key: 'p_update',
        align: 'center',
        render: (text, record) => renderPermissionCheckbox(record, 'p_update', handlePermissionChange, record?.hide),
    },
    {
        title: 'Delete',
        dataIndex: 'delete',
        key: 'delete',
        align: 'center',
        render: (text, record) => renderPermissionCheckbox(record, 'delete', handlePermissionChange, record?.hide),
    },
];
